import {useData} from '../../../../context/ConfigDataContext';

export const NodeDropdown = ({nodeData, isHidden}) => {
  const {setEditNodeModalOpen, setSelectedNode, treeData, deleteNode, setIsEditMode, setCircuitFormData} = useData();

  if (isHidden) return null;

  const openModal = () => {
    setSelectedNode(nodeData.name);
    setEditNodeModalOpen(nodeData.type);
    if (nodeData.type === 'circuit') {
      setCircuitFormData(nodeData.attributes);
    }
    setIsEditMode(true);
  };

  const deleteTreeNode = () => {
    deleteNode(treeData, nodeData.name);
  };

  return (
    <div
      className="island btn-group-vertical z-3"
      style={{
        position: 'absolute',
        top: '100%',
        left: '-300%',
        backgroundColor: 'white',
        border: '1px solid black',
        borderRadius: '10px',
        zIndex: 10,
      }}
    >
      <button onClick={openModal} type="button" className="btn btn-primary">Edit</button>
      <button onClick={deleteTreeNode} type="button" className="btn btn-danger">Delete</button>
    </div>
  );
};

export default NodeDropdown;

